import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Wenjuan = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="c73c9__a">
              <rect
                rx="0"
                height="20"
                width="20"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#c73c9__a)">
            <g fill="#FFA52E">
              <rect
                rx="1.875"
                height="15"
                width="16.667"
                y="2.5"
                x="1.667"
              />
              <path d="M1.042 15.625V4.375q0-1.036.732-1.768t1.768-.732h12.916q1.036 0 1.768.732t.732 1.768v11.25q0 1.035-.732 1.768-.732.732-1.768.732H3.542q-1.036 0-1.768-.732-.732-.733-.732-1.768Zm1.25 0q0 .518.366.884t.884.366h12.916q.518 0 .884-.366t.366-.884V4.375q0-.518-.366-.884t-.884-.366H3.542q-.518 0-.884.366t-.366.884v11.25Z" />
            </g>
            <path
              fill="#FFF8E8"
              fillRule="evenodd"
              d="M1.042 6.458h17.916v-1.25H1.042v1.25Zm7.291 4.167H15a.625.625 0 0 0 0-1.25H8.333a.625.625 0 1 0 0 1.25Zm0 3.333H15a.625.625 0 0 0 0-1.25H8.333a.625.625 0 1 0 0 1.25ZM4.375 10c0 .345.28.625.625.625h.833a.625.625 0 1 0 0-1.25H5a.625.625 0 0 0-.625.625Zm0 3.333c0 .345.28.625.625.625h.833a.625.625 0 1 0 0-1.25H5a.625.625 0 0 0-.625.625Z"
            />
          </g>
        </g>
      </svg>
    )
  }
)
